module.exports = __webpack_public_path__ + "static/logo-bb@2x-d36cd0d899635fdbe55edf8050a0e5e3.png";